import React, { createContext } from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";

import { getArticleArrayFromQuery, getRelatedArticles } from "../utils/blog";

export const RelatedArticlesContext = createContext();

export function RelatedArticlesProvider({
  limit,
  categories,
  tags,
  slug,
  children,
}) {
  const { allMarkdownRemark } = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        ...ArticleListData
      }
    }
  `);

  const articles = getArticleArrayFromQuery(allMarkdownRemark);
  const relatedArticles = getRelatedArticles({
    articles,
    currSlug: slug,
    tags,
    categories,
    limit: limit,
  });

  return (
    <RelatedArticlesContext.Provider value={relatedArticles}>
      {children}
    </RelatedArticlesContext.Provider>
  );
}

RelatedArticlesContext.propTypes = {
  limit: PropTypes.number,
  categories: PropTypes.arrayOf(PropTypes.string.isRequired),
  tags: PropTypes.arrayOf(PropTypes.string.isRequired),
  slug: PropTypes.string.isRequired,
};
